import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import chairman from "../images/Naresh Chandra Das _Chairman.jpeg";



function NareshChandraDas() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
         <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>
        <div className='cbscschoolnadia'>
        <div className='album py-1'>
          <div className='container mt-3'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Chairman <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></li>
              </ol>
            </nav>
          </div>
        </div>
        </div>
        <ScrollToTop smooth top="100" color="darkgoldenrod"/>
        <br/>
        <div className="album py-0">
                    <div className="container">
                        
                            <div className="card-body">
                              <div className='welcometext'>
                                        <h1 className="card-title mb-3"><b>Message from the Chairman</b></h1>
                                        </div>
                                        <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <div class="card">
                        <img src={chairman} className="card-img-top" alt="chairman"/>
                        </div>

                            </div>
                            <div className="col-md-9 mt-3">
                            <p className='mb-2'>We are glad that you are considering Krishnagar Public School for your child's future. Education is the basis of all progress and an education of the highest quality is the greatest gift that parents can give to their children. </p>
                            <p className='justify mb-2'>The entire purpose of education is not only to restrict itself to imparting bookish knowledge, but to inculcate humanitarian values like wisdom, compassion, courage, humility, integrity and reliability in a student </p>
                            <p className='justify mb-2'>We believe in joyful experiential learning wherein each child is encouraged to participate wholeheartedly. We strive to leave no stone unturned to offer multitudes of opportunities to our children and empower them in a way whereby they are able to become representative of a meaningful and value-based society. Our holistic and comprehensive pedagogy complements this vision. </p>
                            <p className='justify mb-2'>We have a team of highly qualified and trained facilitators under the able leadership of Principal Dr. Sankar Prasad Dutta who display boundless energy and commitment which keeps the ethos of our school shining brightly. </p>
                            </div>
                            </div>
                            </div>
                            </div>
                                        <br/>
                                        

                                       

                                       
                                        <div className="d-flex justify-content-end align-items-end mb-0">
                                    <div className='teamkps'>
                                        <p className='mb-0'>Naresh Chandra Das 
                                        </p>
                                        <h5>Chairman </h5>
                                        </div>
                                    
                                </div>
</div>
</div>
</div>
      

      
    </div>
  )
}

export default NareshChandraDas